import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SDDispatchToFieldService } from '../../Services/DSDispatchToField/DS-Dispatch-To-Field.service';
import { DropDownService } from '../../Services/DropDown/dropdownService';
import { RegionModel, RMHModel } from '../../models/DropDwon/RegionModel';
import { ZoneModel } from '../../models/DropDwon/ZoneModel';
import { DivisionModel } from '../../models/DropDwon/DvisionModel';
import { SBUModel } from '../../models/DropDwon/SBUModel';
import { DropDownRequest, DropDownResponse, WHLocationModel, SDModel, RequirmentTypeModel } from '../../models/DropDwon/DropDownRequest';
import { productModel } from '../../models/DropDwon/ProductModel';
import { CropModel } from '../../models/DropDwon/CropModel';
import { DSDispatchToFieldTeamRequestModel, DSDispatchToFieldTeamResponseModel, DSDispatchToFieldTeamModel } from '../../models/DSDispatchToField/DS-Dispatch-To-Field.model'
import { ToastrService } from 'ngx-toastr';
import { saveAs } from 'file-saver';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { YearModel } from 'src/app/Models/DropDwon/YearModel';



@Component({
    selector: 'app-dispatchtofield',
    templateUrl: './DS-Dispatch-To-Field.component.html',
    providers: [DatePipe]
})
export class DSDispatchToFieldComponent implements OnInit {

    @ViewChild('regionSelect') regionSelect;
    @ViewChild('warehouseLocation') warehouseLocation;
    @ViewChild('sbu') sbu;
    @ViewChild('division') division;
    @ViewChild('zone') zone;
    @ViewChild('rmh') rmh;
    @ViewChild('productSelect') productSelect;
    @ViewChild('cropSelect') cropSelect;
    @ViewChild('requirmentType') requirmentType;
    @ViewChild('dispatchStatus') dispatchStatus;
    @ViewChild('file') file;
    @ViewChild('batchSelect') batchSelect;
    @ViewChild('invoiceSelect') invoiceSelect;
    @ViewChild('packSizeSelect') packSizeSelect;
    @ViewChild('yearSelect') yearSelect ;
    @ViewChild('year') year;
  


    public dropdownMonthSettings: {};

    public RegionSettings = {};
    public RegionselectedItems: RegionModel[];

    public RMHSettings = {};
    public RMHSelectedItems: RMHModel[];

    public WarehouseLocationSettings = {};
    public WarehouseLocationSelectedItem: WHLocationModel[];

    public SBUSettings = {};
    public SBUSelectedItem: SBUModel[];

    public DivisionSettings = {};
    public DivisionSelectedItem: DivisionModel[];

    public ZoneSettings = {};
    public ZoneSelectedItem: ZoneModel[];

    public ProductSettings = {};
    public ProductSelectedItem: productModel[];

    public CropSettings = {};
    public CropSelectedItem: CropModel[];

    public RequirmentTypeSettings = {};
    public requirmentTypeDdl: RequirmentTypeModel[];
    public requirmentDllValue: any;

    public DispatchStatusSettings = {};
    public dispatchStatusDDL: any;

    public BatchSettings = {};
    public InvoiceSettings = {};
    public AddPackSizeSettings = {};

    public YearSettings= {};
    public YearSelectedItem: YearModel[];

    public userId: string;
    public roleId: string;
    public FlagDropDown: string;
    public loader: string = "none";
    public files: File[] = [];
    public fileName: string = '';
    public ddlRequest: DropDownRequest = new DropDownRequest();
    public ddlResponse: DropDownResponse = new DropDownResponse();
    public whlocationList: WHLocationModel[];

    public dsDispatchRequest: DSDispatchToFieldTeamRequestModel = new DSDispatchToFieldTeamRequestModel();
    public dsDispatchResponse: Array<DSDispatchToFieldTeamResponseModel> = new Array<DSDispatchToFieldTeamResponseModel>();
    public defaultValue: string = 'none';

    dsDispatchGrid: any = [];
    public dsDispatchGridForApprove: any;
    public dsDispatchGridColumn: any;
    displayReject = 'none';
    userName: string;
    sampleAllocatedDate: Date = new Date();
    lRDate: Date = new Date();
    expDate: Date = new Date();
    mfgDate: Date = new Date();
    invVoDate: Date = new Date();
    schemeStartDate: Date = new Date();
    schemeEndDate: Date = new Date();
    salesFromRange: any = '2010';
    salesToRange: any = '2030';
    public dsDispatchModel: DSDispatchToFieldTeamModel = new DSDispatchToFieldTeamModel();
    selectedRegionMessage: any[] = [];
    qtyTotal: number[] = [];
    submitEnable: boolean = false;
    CurrentYear: string;
    currentMonth: any;
    isDispatch: string;
    productPackSize: any[] = [];
    totalRemainingPacks: any;
    myDate = new Date();
    debugger;
    regionName:string;
    constructor(private router: Router, private sddispatchService: SDDispatchToFieldService, private ddlServices: DropDownService, private toastr: ToastrService,private datePipe: DatePipe) {
        this.userId = localStorage.getItem('dsu_userId');
        this.roleId = localStorage.getItem('dsu_roleId');
        this.userName = localStorage.getItem('dsu_userName');
        this.FlagDropDown = "DEFAULT";
       
    }

    

    ngOnInit() {
        debugger;
        let currentDate = new Date();
        this.currentMonth = currentDate.getMonth() + 1;
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.requirmentTypeDdl =  [{ id: 1, text: "H1" },{ id: 2, text: "H2" },  { id: 3, text: "Additional" }];
        this.dispatchStatusDDL = [{ id: 1, text: "Dispatched" }, { id: 2, text: "Partially Dispatched" }, { id: 3, text: "Not Dispatched" }]
        this.ddlServices.getAllHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse = response.data;
                    this.GetWarehouseLocationData();
                    this.ddlResponse.year=response.data.year;
                    class YearItemList{
                        id: any;
                        text: any;
                    }
                      let requiredItem: YearItemList[] = [];
                      var obj = {
                        id : this.ddlResponse.year[0].currentrequirementYear,
                        text: this.ddlResponse.year[0].currentrequirementYear
                      }
                      requiredItem.push(obj)
                      this.year.selectedItems = requiredItem
                      for(var i=0;i<this.year.selectedItems.length; i++){
                          this.yearSelect.push(this.year.selectedItems[i].text)
                      }
                    this.YearSetting();
                    this.loader = 'none';
                }
                else {
                    this.loader = 'none';
                    this.toastr.error(response.message);
                }

            }, error => {
                this.loader = 'none';
            });
        this.CurrentYear = (new Date()).getFullYear().toString();
        this.SBUMHSetting();
        this.DivisionSetting();
        this.ZoneSetting();
        this.RegionSetting();
        this.RMHSetting();
        this.WareHouseLocationSetting();
        this.CropSetting();
        this.ProductSetting();
        this.RequirmentTypeSetting();
        this.DispatchedStatusSetting();
        this.BatchSetting();
        this.InvoiceSetting();
        this.AddPackSizeSetting();
        this.YearSetting();
    }


    RegionSetting() {
        this.RegionSettings = {
            singleSelection: false,
            idField: 'regionCode',
            textField: 'regionName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            //maxHeight: 197,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Region Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    
    YearSetting(){
        this.YearSettings = {
          singleSelection: true,
          idField: 'year',
          textField: 'year',
          enableCheckAll: false,
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          allowSearchFilter: false,
          limitSelection: -1,
          clearSearchFilter: false,
          itemsShowLimit: 1,
          searchPlaceholderText: 'Search',
          noDataAvailablePlaceholderText: 'No Year Found',
          closeDropDownOnSelection: false,
          showSelectedItemsAtTop: false,
          defaultOpen: false
        };
    }
    RMHSetting() {
        this.RMHSettings = {
            singleSelection: false,
            idField: 'rmhCode',
            textField: 'rmhName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            //maxHeight: 197,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No RMH Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    public onRegionSelect(item: any) {
        if (this.roleId != '42' && this.roleId != '76' && (this.roleId=='53' || this.roleId=='1' || this.roleId=='37')) {
            //this.GetRegionWiseData(this.regionSelect.selectedItems);
            //this.GetSDRegionWise(this.regionSelect.selectedItems);
            //this.GetWarehouseLocationData();
        }
        else{
            this.GetRegionWiseData(this.regionSelect.selectedItems);
        }
    }
    public onRegionDeSelect(item: any) {
        if (this.roleId != '42' && this.roleId != '76' && (this.roleId=='53' || this.roleId=='1' || this.roleId=='37')) {
      //      this.warehouseLocation.selectedItems = [];
            this.GetRegionWiseData(this.regionSelect.selectedItems);
            //this.GetWarehouseLocationData();
        }
    }

    public onRegionSelectAll(items: any) {
        if (this.roleId != '42' && this.roleId != '76') {
            this.GetRegionWiseData(this.regionSelect.selectedItems);
        }
    }
    public onRegionDeSelectAll(items: any) {
        debugger
        this.rmh.selectedItems = [];
        //this.GetRegionWiseData(this.regionSelect.selectedItems);
    }
    public onRMHSelect(item: any) {
        if (this.roleId != '42' && this.roleId != '76' && (this.roleId=='53' || this.roleId=='1' || this.roleId=='37') ){    
        this.GetRMHWiseData(this.rmh.selectedItems);
        
        //this.GetSDRegionWise(this.regionSelect.selectedItems);
        //this.GetWarehouseLocationData();
        }
        else{
            this.GetRMHWiseData(this.rmh.selectedItems);
            this.getSDRMHWise(this.rmh.selectedItems);
        }
    }
    public onRMHDeSelect(item: any) {
     //   this.warehouseLocation.selectedItems = [];
        this.GetRMHWiseData(this.rmh.selectedItems);
        // this.getSDRMHWise(this.rmh.selectedItems);
        //this.GetWarehouseLocationData();
    }

    // public onWHSelect(item: any) {
    //     this.batchSelect.selectedItems=[];
    //     this.GetBatchNo();
    // }
    // public onWHDeSelect(item: any) {
    //     this.batchSelect.selectedItems=[];
    //     this.GetBatchNo();
    // }

    // public onProductSelect(item: any) {
    //     this.batchSelect.selectedItems=[];
    //     this.GetBatchNo();
    // }
    // public onProductDeSelect(item: any) {
    //     this.batchSelect.selectedItems=[];
    //     this.GetBatchNo();
    // }


    public onWHSelect(item: any) {
        debugger;
        this.invoiceSelect.selectedItems = [];
        this.GetInvoiceNo();
        this.FlagDropDown = 'FILTER';
        this.GetWarehouseWiseData(this.warehouseLocation.selectedItems);
        this.FlagDropDown = "DEFAULT";
    }
    public onWHDeSelect(item: any) {
        this.invoiceSelect.selectedItems = [];
        this.GetInvoiceNo();
        this.GetWarehouseWiseData(this.warehouseLocation.selectedItems);
    }

    public onProductSelect(item: any) {
        this.invoiceSelect.selectedItems = [];
        this.GetInvoiceNo();
    }
    public onProductDeSelect(item: any) {
        this.invoiceSelect.selectedItems = [];
        this.GetInvoiceNo();
    }




    public onRMHSelectAll(items: any) {

        this.GetRMHWiseData(this.rmh.selectedItems);
        this.getSDRMHWise(this.rmh.selectedItems);
    }
    public onRMHDeSelectAll(items: any) {
        this.regionSelect.selectedItems = [];
    //    this.warehouseLocation.selectedItems = [];
        //this.GetRMHWiseData(this.rmh.selectedItems);
        this.GetRMHWiseData(this.rmh.selectedItems);
        // this.getSDRMHWise(this.rmh.selectedItems);
        //this.GetWarehouseLocationData();
    }
    RequirmentTypeSetting() {
        this.RequirmentTypeSettings = {
            singleSelection: true,
            idField: 'id',
            textField: 'text',
            enableCheckAll: false,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: false,
            limitSelection: -1,
            clearSearchFilter: false,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Requirment Type Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    DispatchedStatusSetting() {
        this.DispatchStatusSettings = {
            singleSelection: true,
            idField: 'id',
            textField: 'text',
            enableCheckAll: false,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: false,
            limitSelection: -1,
            clearSearchFilter: false,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Dispatch Status Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    CropSetting() {
        this.CropSettings = {
            singleSelection: false,
            idField: 'cropId',
            textField: 'cropName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Crop Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    ProductSetting() {
        this.ProductSettings = {
            singleSelection: true,
            idField: 'productId',
            textField: 'productName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Product Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }

    BatchSetting() {
        this.BatchSettings = {
            singleSelection: true,
            idField: 'batchNo',
            textField: 'batchNoText',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Batch Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }

    InvoiceSetting() {
        this.InvoiceSettings = {
            singleSelection: true,
            idField: 'invoiceNo',
            textField: 'invoiceNoText',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Invoice Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }

    AddPackSizeSetting() {
        this.AddPackSizeSettings = {
            singleSelection: true,
            idField: 'packSize',
            textField: 'packSize',
            allowSearchFilter: true,
            clearSearchFilter: true,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Pack Size Found',
            closeDropDownOnSelection: true,

        };
    }

    WareHouseLocationSetting() {
        this.WarehouseLocationSettings = {
            singleSelection: true,
            idField: 'whId',
            textField: 'whName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Warehouse Location Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    SBUMHSetting() {
        this.SBUSettings = {
            singleSelection: false,
            idField: 'sbuCode',
            textField: 'sbuName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No SBU Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    DivisionSetting() {
        this.DivisionSettings = {
            singleSelection: false,
            idField: 'divisionCode',
            textField: 'divisionName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Division Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    ZoneSetting() {
        this.ZoneSettings = {
            singleSelection: false,
            idField: 'zoneCode',
            textField: 'zoneName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Zone Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    bindMonthDropdownSetting() {
        this.dropdownMonthSettings = {
            singleSelection: false,
            text: "Select Month",
            idField: 'Id',
            textField: 'Text',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 1,
            allowSearchFilter: true,
            noDataAvailablePlaceholderText: 'No Month Found'
        };
    }

    public onSBUSelect(item: any) {
        this.GetSBUWiseData(this.sbu.selectedItems);
    }
    public onSBUDeSelect(item: any) {
        this.GetSBUWiseData(this.sbu.selectedItems);
    }

    public onSBUSelectAll(items: any) {
        this.GetSBUWiseData(this.sbu.selectedItems);
    }
    public onSBUDeSelectAll(items: any) {
        this.GetSBUWiseData(this.sbu.selectedItems);
    }

    public onDivisionSelect(item: any) {
        this.GetDivisionWiseData(this.division.selectedItems);

    }
    public onDivisionDeSelect(item: any) {
        this.GetDivisionWiseData(this.division.selectedItems);
    }

    public onDivisionSelectAll(items: any) {
        this.GetDivisionWiseData(this.division.selectedItems);
    }
    public onDivisionDeSelectAll(items: any) {
        this.GetDivisionWiseData(this.division.selectedItems);
    }

    public onZoneSelect(item: any) {

        this.GetZoneWiseData(this.zone.selectedItems);
    }
    public onZoneDeSelect(item: any) {
        this.GetZoneWiseData(this.zone.selectedItems);
    }

    public onZoneSelectAll(items: any) {
        this.GetZoneWiseData(this.zone.selectedItems);
    }
    public onZoneDeSelectAll(items: any) {
        this.GetZoneWiseData(this.zone.selectedItems);
        this.rmh.selectedItems = [];
        this.regionSelect.selectedItems = [];
    }

    GetSBUWiseData(filter: any) {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.SBU = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getSBUHierarchyDropDown(this.ddlRequest)
            //this.ddlServices.getZoneHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse.division = response.data.division;
                    this.ddlResponse.zone = response.data.zone;
                    this.ddlResponse.region = response.data.region;
                    this.ddlResponse.rmh = response.data.rmh;

                    this.division.selectedItems = response.data.division.map(item => { return { id: item.divisionCode, text: item.divisionName } });
                    this.zone.selectedItems = response.data.zone.map(item => { return { id: item.zoneCode, text: item.zoneName } });
                    this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
                    this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });

                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }
    GetDivisionWiseData(filter: any) {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.Division = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getDivisionHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse.region = response.data.region;
                    this.ddlResponse.zone = response.data.zone;
                    this.ddlResponse.rmh = response.data.rmh;

                    this.zone.selectedItems = response.data.zone.map(item => { return { id: item.zoneCode, text: item.zoneName } });
                    this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
                    this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });

                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }
    GetZoneWiseData(filter: any) {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.Zone = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getZoneHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.rmh.selectedItems = [];
                    this.regionSelect.selectedItems = [];
                    this.ddlResponse.region = response.data.region;
                    this.ddlResponse.rmh = response.data.rmh;

                    this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
                    this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }

    GetRegionWiseData(filter: any) {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.Region = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getRegionWiseRMHDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    if (response.data.rmh.length > 0) {
                        this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });
                     //   this.getSDRMHWise(this.rmh.selectedItems);
                    }

                    else
                        this.rmh.selectedItems = [];

                    //this.ddlResponse.rmh = response.data.rmh;
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }
    GetRMHWiseData(filter: any) {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.RMH = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getRMHWiseRegionDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    debugger
                    if (response.data.region.length > 0)
                        this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
                    else
                        this.regionSelect.selectedItems = [];
                    //this.ddlResponse.region = response.data.region;
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }



    //IsOnInit==>True Means It execute on ngOnInit
    //IsOnInit==>False Means It execute on OnChnage
    GetWarehouseLocationData() {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = 'TRUE';
        this.ddlServices.getWarehouseLocationDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse.warehouseLocation = response.data.warehouse;
                    this.loader = 'none';
                    return false;
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }


    downloadFile() {
        this.dsDispatchRequest.requirmentType = Array.prototype.map.call(this.requirmentType.selectedItems, function (item) { return item.text; }).join(",");
        if (this.dsDispatchRequest.requirmentType === "" || this.dsDispatchRequest.requirmentType === "undefined") {
            this.toastr.error("Please select requirement type.");
            return false;
        }

        if ((this.roleId == '42' || this.roleId == '76') && this.regionSelect === undefined || this.regionSelect === "") {
            this.dsDispatchRequest.region = '';
        }
        else if (this.regionSelect.selectedItems.length > 0)
            this.dsDispatchRequest.region = Array.prototype.map.call(this.regionSelect.selectedItems, function (item) { return item.id; }).join(",");

        else {
            this.toastr.error("Please select region.")
            this.dsDispatchRequest.region = '';
            return false;
        }
        if ((this.roleId == '42' || this.roleId=='76') && this.rmh === undefined || this.rmh === "") {
            this.dsDispatchRequest.rmhCode = ''
        }
        else if (this.rmh.selectedItems.length > 0) {
            this.dsDispatchRequest.rmhCode = Array.prototype.map.call(this.rmh.selectedItems, function (item) { return item.id; }).join(",");
        } else {
            this.dsDispatchRequest.rmhCode = ''
        }
        if (this.warehouseLocation.selectedItems.length > 0)
            this.dsDispatchRequest.whLocation = Array.prototype.map.call(this.warehouseLocation.selectedItems, function (item) { return item.id; }).join(",");
        else {
            this.dsDispatchRequest.whLocation = '';
            this.toastr.error("Please select warehouse location.");
            return false;
        }


        if (this.productSelect.selectedItems.length > 0)
            this.dsDispatchRequest.product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
        else {
            this.dsDispatchRequest.product = '';
            this.toastr.error("Please select product.");
            return false;
        }


        // if (this.batchSelect.selectedItems.length > 0)
        //     this.dsDispatchRequest.batch = Array.prototype.map.call(this.batchSelect.selectedItems, function (item) { return item.id; }).join(",");
        // else{
        //     this.dsDispatchRequest.batch = '';
        //     this.toastr.error("Please select batch.");
        //     return false;
        // }


 //
 if (this.invoiceSelect.selectedItems.length > 0)
 {
    this.dsDispatchRequest.invoice= Array.prototype.map.call(this.invoiceSelect.selectedItems, function (item) { return item.id; }).join(",");
 }
else {
    this.dsDispatchRequest.invoice = '';
 this.toastr.error("Please select invoice.");
 return false;
}
 //
        this.dsDispatchRequest.userId = this.userId;
        // this.dsDispatchRequest.region = Array.prototype.map.call(this.regionSelect.selectedItems, function (item) { return item.id; }).join(",");
        if (this.dispatchStatus.selectedItems.length > 0)
            //this.dsDispatchRequest.isDispatched = this.dispatchStatus.selectedItems[0].id === 1 ? true : false;
            this.dsDispatchRequest.isDispatched = Array.prototype.map.call(this.dispatchStatus.selectedItems, function (item) { return item.text; }).join(",");
        else {
            this.dsDispatchRequest.isDispatched = '';
            this.toastr.error("Please select status.");
            return false;
        }
        let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
        this.dsDispatchRequest.year=year;
        this.dsDispatchRequest.IsExcel = 1
        this.loader = 'block';
        this.sddispatchService.GetExcelFileName(this.dsDispatchRequest)
            .subscribe(returnValue => {
                if (returnValue.message != '') {
                    this.toastr.error(returnValue.message);
                    //alert(returnValue.message);
                    this.loader = 'none';
                }
                else {
                    this.downloadLink(returnValue.filePath);
                }
            }, error => {
                this.loader = 'none';
            });
    }
    downloadLink(Path: string): void {
        let today = new Date();
        let month;
        let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");

        if((today.getMonth() + 1)<10)
        {
            month = '0' + (today.getMonth() + 1).toString().slice(-2);
        }
        else
        {
            month =  (today.getMonth() + 1).toString().slice(-2);
        }
        let formattedDate = today.getDate() + "_" + month + "_" + today.getFullYear();
        this.dsDispatchRequest.fileUrl = Path;
        this.sddispatchService.DownloadFile(this.dsDispatchRequest).subscribe(
            success => {
                saveAs(success, this.userName + "_" + year + "_DispatchToField_" + formattedDate + ".xlsx");
                this.loader = 'none';
            },
            err => {
                this.toastr.error("Some problem occurred while downloading file.");
                //alert("Some problem occurred while downloading file.");
                this.loader = 'none';

            }
        );
    }
    fileUpload(files: File[]) {
        this.files = [];
        this.files = files;
        let fileNameParts: string[] = files[0].name.split('.');
        let fileType = files[0].name.split('.')[fileNameParts.length - 1];
        let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
        let requirmentType = Array.prototype.map.call(this.requirmentType.selectedItems, function (item) { return item.text; }).join(",");
       
        if (fileType != 'xls' && fileType != 'xlsx') {
            this.file.nativeElement.value = '';
            // this.snackBar.openSnackBar('Please Select Valid File Type.','Close','red-snackbar');
            this.toastr.error("Please Select Valid File Type.");
            return false;
        }
        if (requirmentType === "" || requirmentType === "undefined") {
            this.file.nativeElement.value = '';
            this.toastr.error("Please Select Requirment Type.");
            return false;
        }
        this.loader = 'block';
        let fileValue = <File>this.files[0];
        
        this.sddispatchService.uploadDocument(fileValue, this.userId, requirmentType,year)
            .subscribe((resData: any) => {
                console.log(resData);
                if (resData.status) {

                    // if (resData.data[0].result === "Success") {
                    //     //this.toastr.success(resData.data[0].errordescription);
                    //     //alert(resData.data[0].errordescription);
                    //     this.toastr.success(resData.data[0].errordescription);
                    //     //location.reload();
                    // }
                    // else {
                    //     this.toastr.error(resData.data[0].errordescription);
                    // }
                    this.toastr.success(resData.message);
                }
                else {
                    this.toastr.error(resData.message);
                }
                this.defaultValue = "none";
                this.file.nativeElement.value = '';
                this.loader = 'none';
            }, error => {
                this.file.nativeElement.value = '';
                this.loader = 'none';
                this.toastr.error('Some Problem Occured,Please try again later.');
            });

    }

    GetStockOutData() {
       
        let year =0;
        year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
        this.dsDispatchRequest.year=year;
        this.dsDispatchRequest.userId = this.userId; 
        this.dsDispatchRequest.requirmentType = Array.prototype.map.call(this.requirmentType.selectedItems, function (item) { return item.text; }).join(",");
        if (this.dsDispatchRequest.requirmentType === "" || this.dsDispatchRequest.requirmentType === "undefined") {
            this.toastr.error("Please select requirement type.");
            return false;
        }
        if ((this.roleId == '42' || this.roleId == '76' || this.roleId == '77') && this.regionSelect === undefined || this.regionSelect === "") {
            this.dsDispatchRequest.region = '';
        }
        else if (this.regionSelect.selectedItems.length > 0)
            this.dsDispatchRequest.region = Array.prototype.map.call(this.regionSelect.selectedItems, function (item) { return item.id; }).join(",");

        else {
            this.toastr.error("Please select region.")
            this.dsDispatchRequest.region = '';
            return false;
        }
        if ((this.roleId == '42' || this.roleId=='76' || this.roleId == '77') && this.rmh === undefined || this.rmh === "") {
            this.dsDispatchRequest.rmhCode = ''
        }
        else if (this.rmh.selectedItems.length > 0) {
            this.dsDispatchRequest.rmhCode = Array.prototype.map.call(this.rmh.selectedItems, function (item) { return item.id; }).join(",");
        } else {
            this.dsDispatchRequest.rmhCode = ''
        }

        if (this.warehouseLocation.selectedItems.length > 0)
            this.dsDispatchRequest.whLocation = Array.prototype.map.call(this.warehouseLocation.selectedItems, function (item) { return item.id; }).join(",");
        else {
            this.dsDispatchRequest.whLocation = '';
            this.toastr.error("Please select warehouse location.");
            return false;
        }


        if (this.productSelect.selectedItems.length > 0)
            this.dsDispatchRequest.product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
        else {
            this.dsDispatchRequest.product = '';
            this.toastr.error("Please select product.");
            return false;
        }


        // if (this.batchSelect.selectedItems.length > 0)
        //     this.dsDispatchRequest.batch = Array.prototype.map.call(this.batchSelect.selectedItems, function (item) { return item.id; }).join(",");
        // else{
        //     this.dsDispatchRequest.batch = '';
        //     this.toastr.error("Please select batch.");
        //     return false;
        // }

        if (this.invoiceSelect.selectedItems.length > 0)
            this.dsDispatchRequest.invoice = Array.prototype.map.call(this.invoiceSelect.selectedItems, function (item) { return item.id; }).join(",");
        else {
            this.dsDispatchRequest.invoice = '';
            this.toastr.error("Please select invoice.");
            return false;
        }



        if (this.dispatchStatus.selectedItems.length > 0)
            //this.dsDispatchRequest.isDispatched = this.dispatchStatus.selectedItems[0].id === 1 ? true : false;
            this.dsDispatchRequest.isDispatched = Array.prototype.map.call(this.dispatchStatus.selectedItems, function (item) { return item.text; }).join(",");
        else {
            this.toastr.error("Please select status.")
            this.dsDispatchRequest.isDispatched = '';
            return false;
        }
        this.loader = 'block';
        this.sddispatchService.getStockoutScreenData(this.dsDispatchRequest)
            .subscribe((response) => {
                if (response.status) {
                    debugger;
                    this.defaultValue = 'block';

                    this.dsDispatchGrid = response.data.getDispatchToFieldModels;
                    if (this.dsDispatchGrid.length > 0) {
                        this.isDispatch = this.dsDispatchGrid[0].status;
                    }
                    else {
                        this.isDispatch = "Dispatched";
                    }
                    

                    if (this.dsDispatchGrid.length > 0) {
                        //this.productPackSize.values= null;
                        this.productPackSize = [];
                        for (let i = 0; i < response.data.packSizeModel.length; i++) {
                            let packSize: any = {};
                            packSize.packSize = response.data.packSizeModel[i].packSize;
                            this.productPackSize.push(packSize);
                        }

                        // for (var i = 0; i < this.dsDispatchGrid.length; i++) {
                        //     //this.productPackSize = this.dsDispatchGrid[0].packSize;
                        //     let PackSizes = this.dsDispatchGrid[i].packSize;
                        //     let totalQTYToDispatchDd = this.dsDispatchGrid[i].totalQTYToDispatch;

                        //     if (PackSizes == '') {
                        //         PackSizes = 0;
                        //     } else {
                        //         if (PackSizes.indexOf("LTR") !== -1 || PackSizes.indexOf("LT") !== -1 || PackSizes.indexOf("KG") !== -1) {
                        //             let valueLtrKg = 1;
                        //             PackSizes = valueLtrKg * parseInt(totalQTYToDispatchDd);
                        //         }
                        //         else if (PackSizes.indexOf("ML") !== -1 || PackSizes.indexOf("GM") !== -1) {
                        //             //nwValuePackSize = ((1000 * parseInt(totalQTYToDispatchD)) / parseInt(nwValuePackSize)).toFixed(2);
                        //             PackSizes = ((1000 * parseInt(totalQTYToDispatchDd)) / parseInt(PackSizes));
                        //         }
                        //         this.dsDispatchGrid[i]['finalAllottedQTY'] = PackSizes;
                        //     }
                        // }
                    }

                    this.selectedRegionMessage = [];
                    if (this.dsDispatchGrid != null) {
                        this.selectedRegionMessage.push({ region: this.dsDispatchGrid[0].region, status: this.dsDispatchGrid[0].status })
                        for (var i = 0; i < this.dsDispatchGrid.length; i++) {

                            for (var j = 0; j < this.selectedRegionMessage.length; j++) {
                                if (this.selectedRegionMessage[j].region == this.dsDispatchGrid[i].region) {
                                    break;
                                }

                            }
                            if (j == this.selectedRegionMessage.length) {
                                this.selectedRegionMessage.push({ region: this.dsDispatchGrid[i].region, status: this.dsDispatchGrid[i].status })
                            }
                        }
                    }

                    if (this.selectedRegionMessage.length >= 1) {
                        for (var i = 0; i < this.selectedRegionMessage.length; i++) {
                            if (this.selectedRegionMessage[i].status == 'Not Dispatched') {
                                this.loader = 'none';
                                this.submitEnable = false;
                            }
                            else {
                                this.submitEnable = true;
                            }
                        }
                    }
                    // this.submitEnable = false;
                    this.loader = 'none';
                }
                else {
                    this.submitEnable = false;
                    this.defaultValue = 'none';
                    this.toastr.error('No record found.');
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }

    //#region get all column name
    GetAllKeysFromList(data: any) {
        var response = data.reduce(function (arr, o) {
            return Object.keys(o).reduce(function (a, k) {
                if (a.indexOf(k) == -1) a.push(k);
                return a;
            }, arr)
        }, []);
        return response;
    }
    //#endregion
    // isRequiredField(field: string) {
    //     const form_field = this.dsDispatchGrid.packSize.get(field);
    //     if (!form_field.validator) {
    //         return false;
    //     }
    
    //     const validator = form_field.validator({} as AbstractControl);
    //     return (validator && validator.required);
    // }

    textChange(newValueJan, i, key) {

        let nwValue = newValueJan.target.value;
        if (nwValue == '') {
            nwValue = 0;
        } else {
            nwValue = nwValue;
        }
        let oldvalue = this.dsDispatchGrid[i][key];
        this.dsDispatchGrid[i][key] = nwValue;
        this.totalDispatchedQty(nwValue, i, oldvalue)
        this.noOfpacks(i)
       
    }
    
    ontotalRemainingPacks(i){
        var totalpacks=0;
        for(var j=0;j<this.dsDispatchGrid.length;j++){
            if(this.dsDispatchGrid[j]['isAllocated'].toString() == "0"){
            totalpacks=totalpacks+parseInt(this.dsDispatchGrid[j]['finalAllottedQTY']);
            }
        }
            
        for(var k=0;k<this.dsDispatchGrid.length;k++){
            var packInt=this.dsDispatchGrid[k].packSize.split(" ");
            var packSizeInt=packInt[0];
            if (this.dsDispatchGrid[k].packSize.indexOf("LTR") !== -1 || this.dsDispatchGrid[k].packSize.indexOf("LT") !== -1 || this.dsDispatchGrid[k].packSize.indexOf("KG") !== -1) {
                this.dsDispatchGrid[k]['remainingQtyPack']= parseInt(((this.dsDispatchGrid[k]['totalRemainingQTY'])-(totalpacks)).toFixed(2));
                return this.dsDispatchGrid[k]['remainingQtyPack'];
            }
            else{    
            this.dsDispatchGrid[k]['remainingQtyPack']=parseInt((((this.dsDispatchGrid[k]['totalRemainingQTY'] * 1000) / packSizeInt)-(totalpacks)).toFixed(2));
            }
            return this.dsDispatchGrid[k]['remainingQtyPack'];
        }    
        
    }
    
    noOfpacks(index: any){
        if(this.dsDispatchGrid[index]['isAllocated'].toString() == "0"){
            this.dsDispatchGrid[index]['finalAllottedQTY'] = parseInt(this.dsDispatchGrid[index]['totalQTYToDispatch']);
        }
        else {
            this.dsDispatchGrid[index]['finalAllottedQTY'];
        }     
    }
    totalDispatchedQty(nwValue: any, index: any, oldvalue: any) {
        this.dsDispatchGrid[index]['totalQTYToDispatch'] = parseInt(this.dsDispatchGrid[index]['totalQTYToDispatch']) + parseInt(nwValue) - parseInt(oldvalue);
        
    }
    onDateSelectSampleAllocatedDate(newValueSampleAllocatedDate, i) {
        let nwValue = newValueSampleAllocatedDate;
        var datePipe = new DatePipe("en-US");
        nwValue = datePipe.transform(nwValue, 'dd/MMM/yyyy hh:mm a')
        this.dsDispatchGrid[i]['sampleAllocatedDate'] = nwValue;
    }
    onDateSelectAllocationDate(newValueAllocationDate, i) {
        let nwValue = newValueAllocationDate;
        var datePipe = new DatePipe("en-US");
        nwValue = datePipe.transform(nwValue, 'dd/MMM/yyyy hh:mm a')
        this.dsDispatchGrid[i]['allocatedDate'] = nwValue;
    }
    textChangeChallanNo(newValueChallanNo, i, key) {
        let nwValue = newValueChallanNo.target.value;
        this.dsDispatchGrid[i][key] = nwValue;
    }
    textChangeNoOfCases(newValueNoOfCases, i, key) {
        let nwValue = newValueNoOfCases.target.value;
        this.dsDispatchGrid[i][key] = nwValue;
    }
    textChangeBatchNo(newValueBatchNo, i, key) {
        let nwValue = newValueBatchNo.target.value;
        this.dsDispatchGrid[i][key] = nwValue;
    }
    onDateSelectMFGDate(newValueMFGDate, i) {
        let nwValue = newValueMFGDate;
        var datePipe = new DatePipe("en-US");
        nwValue = datePipe.transform(nwValue, 'dd/MMM/yyyy hh:mm a')
        this.dsDispatchGrid[i]['mfgDate'] = nwValue;
    }
    onDateSelectEXPDate(newValueEXPDate, i) {
        let nwValue = newValueEXPDate;
        var datePipe = new DatePipe("en-US");
        nwValue = datePipe.transform(nwValue, 'dd/MMM/yyyy hh:mm a')
        this.dsDispatchGrid[i]['expDate'] = nwValue;
    }
    textChangeLRNo(newValueLRNo, i, key) {
        let nwValue = newValueLRNo.target.value;
        this.dsDispatchGrid[i][key] = nwValue;
    }
    onDateSelectLRDate(newValueEXPDate, i) {
        let nwValue = newValueEXPDate;
        var datePipe = new DatePipe("en-US");
        nwValue = datePipe.transform(nwValue, 'dd/MMM/yyyy hh:mm a')
        this.dsDispatchGrid[i]['lrDate'] = nwValue;
    }
    onDateSelectInvovDate(newValueInvVoDate, i) {
        let nwValue = newValueInvVoDate;
        var datePipe = new DatePipe("en-US");
        nwValue = datePipe.transform(nwValue, 'dd/MMM/yyyy hh:mm a')
        this.dsDispatchGrid[i]['invVoDate'] = nwValue;
    }
    textChangeTransPortName(newValueTName, i, key) {
        let nwValue = newValueTName.target.value;
        this.dsDispatchGrid[i][key] = nwValue;
    }
    finalSumbissionDispatchToField(array: any) {
       
        this.dsDispatchModel.AllocatedId = array.allocatedId
        this.displayReject = 'none';
        this.loader = 'block';
        let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
        let isValid = true;
        let data = array.filter(x => x.isSelected == true);
        if (data.length == 0 || data == null) {
            this.toastr.error("Please select any one of the field.");
            this.loader = 'none';
            return false;
        }

        for(var k=0;k<this.dsDispatchGrid.length;k++){
           if(parseInt(this.dsDispatchGrid[k]['remainingQtyPack']) < 0)
           {
             isValid = false;
             this.toastr.error("Total remaining packs to allocate should not be less than zero.");
             this.loader = 'none';
             return false;
           }
        }  

        for (let x = 0; x < data.length; x++) {
            if (!Boolean(data[x].sampleAllocatedDate)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                this.loader = 'none';
                return false;
            }
            if (!Boolean(data[x].transportName)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                this.loader = 'none';
                return false;
            }
        }
        if (isValid) {
            this.sddispatchService.saveFinalApprovalData(data, this.userId,
                Array.prototype.map.call(this.requirmentType.selectedItems,
                    function (item) { return item.text; }).join(","),year)
                .subscribe((response) => {
                    if (response.status) {
                        this.defaultValue = 'none';
                        this.toastr.success('Data submitted successfully.');
                        this.loader = 'none';
                        //location.reload();
                        //this.GetStockOutData();
                    }
                    else {
                        this.toastr.error(response.message);
                        this.loader = 'none';
                    }
                    this.displayReject = 'none';
                }, error => {
                    this.loader = 'none';
                });
        }


    }

    closePopup(commentModal: string) {
        this.displayReject = 'none';
    }
    openCommentPopup(array: any) {
        let data = array.filter(x => x.isSelected == true);
        if (data.length == 0 || data == null) {
            this.toastr.error("Please select any one of the field.");
            return false;
        }
        this.displayReject = 'block';
    }
    reset() {
        this.defaultValue = 'none';
        if (this.requirmentType != undefined) {
            this.requirmentType.selectedItems = [];
        }
        if (this.rmh != undefined) {
            this.rmh.selectedItems = [];
        }
        if (this.productSelect != undefined) {
            this.productSelect.selectedItems = [];
        }
        if (this.sbu != undefined) {
            this.sbu.selectedItems = [];
        }
        if (this.division != undefined) {
            this.division.selectedItems = [];
        }
        if (this.zone != undefined) {
            this.zone.selectedItems = [];
        }
        if (this.regionSelect != undefined) {
            this.regionSelect.selectedItems = [];
        }
        if (this.warehouseLocation != undefined) {
            this.warehouseLocation.selectedItems = [];
        }
        if (this.warehouseLocation != undefined) {
            this.warehouseLocation.selectedItems = [];
        }
        if (this.dispatchStatus != undefined) {
            this.dispatchStatus.selectedItems = [];
        }
    }

    CalculationOnPackSize(newValuePSize, i) {
        let nwValuePackSize = newValuePSize.packSize;
        let originalValuePackSize = this.dsDispatchGrid[i].packSize;
        let totalQTYToDispatchD = this.dsDispatchGrid[i].totalQTYToDispatch;
        if (nwValuePackSize == '') {
            nwValuePackSize = 0;
        } else {
            //this.dsDispatchGrid[i]['packSize'] = nwValuePackSize;
            if (nwValuePackSize.indexOf("LTR") !== -1 || nwValuePackSize.indexOf("LT") !== -1 || nwValuePackSize.indexOf("KG") !== -1) {
                //let valueLtrKg = 1;
                //nwValuePackSize = valueLtrKg * parseInt(totalQTYToDispatchD);

                if (originalValuePackSize.indexOf("LTR") !== -1 || originalValuePackSize.indexOf("LT") !== -1 || originalValuePackSize.indexOf("KG") !== -1) {
                    nwValuePackSize = (Math.ceil((parseInt(originalValuePackSize) * parseInt(totalQTYToDispatchD)) / parseInt(nwValuePackSize)));
                }
                else {
                    nwValuePackSize = (Math.ceil((parseInt(originalValuePackSize) * parseInt(totalQTYToDispatchD)*1000) / (parseInt(nwValuePackSize))));
                }

            }
            else if (nwValuePackSize.indexOf("ML") !== -1 || nwValuePackSize.indexOf("GM") !== -1) {

                if (originalValuePackSize.indexOf("LTR") !== -1 || originalValuePackSize.indexOf("LT") !== -1 || originalValuePackSize.indexOf("KG") !== -1) {
                    nwValuePackSize = (Math.ceil((parseInt(originalValuePackSize) * parseInt(totalQTYToDispatchD) * 1000) / parseInt(nwValuePackSize)));
                }
                else {
                    nwValuePackSize = (Math.ceil((parseInt(originalValuePackSize) * parseInt(totalQTYToDispatchD)) / parseInt(nwValuePackSize)));
                }
            }
            this.dsDispatchGrid[i]['finalAllottedQTY'] = Math.round(nwValuePackSize);
        }
    }

    getSDRMHWise(filter: any) {
        debugger
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.RMH = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getSDRMHWise(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse.sd = response.data.sd;
            //        this.getWHRMHWise(this.ddlRequest.RMH, this.ddlResponse.sd)
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }

    // Get SD Region Wise

    GetSDRegionWise(filter: any) {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.Region = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getSDRegionWise(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) { 
                    //this.ddlResponse.warehouseLocation = response.data.warehouseLocation;                  
                    //this.getWHRMHWise(this.ddlRequest.RMH,this.ddlResponse.sd)
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }
   
    // getRMHRoleId(filter: any) {
    //     this.loader = 'block';
    //     this.ddlRequest.UserId = this.userId;
    //     this.ddlRequest.Role = this.roleId;
    //     this.ddlRequest.Flag = this.FlagDropDown;
    //     this.ddlRequest.RMH = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    //     this.ddlServices.getRMHRoleId(this.ddlRequest)
    //         .subscribe((response) => {
    //             if (response.status) {
    //                 this.ddlResponse.roleId=response.data.ro
    //                // this.getWHRMHWise(this.ddlRequest.RMH, this.ddlResponse.sd)
    //                 this.loader = 'none';
    //             }
    //             else {
    //                 this.toastr.error(response.message);
    //                 this.loader = 'none';
    //             }

    //         }, error => {
    //             this.loader = 'none';
    //         });
    // }


    getWHRMHWise(filter: any, filterSD: any) {
        this.loader = 'block';
        this.warehouseLocation.selectedItems = [];
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.RMH = filter;
        this.ddlRequest.SD = Array.prototype.map.call(filterSD, function (item) { return item.sdCode; }).join(",");
        this.ddlServices.getWHRMHWise(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    if (response.data.warehouse.length == 1) {
                        this.ddlResponse.warehouseLocation = response.data.warehouse;
                        this.warehouseLocation.selectedItems = response.data.warehouse.map(item => { return { id: item.whId, text: item.whName } });
                    }

                    else {
                        this.warehouseLocation.selectedItems = [];
                        this.ddlResponse.warehouseLocation = response.data.warehouse;
                        this.loader = 'none';
                    }
                    this.ddlResponse.warehouseLocation = response.data.warehouse;
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }

    isAllChecked() {
        return this.dsDispatchGrid.every(_ => _.isSelected);
    }

    SelectDisselectAll(ev) {
        this.dsDispatchGrid.forEach(x => x.isSelected = ev.target.checked)
    }

    // GetBatchNo(){
    //     this.ddlResponse.batch = [];
    //     this.loader = 'block';
    //     let whLocation = Array.prototype.map.call(this.warehouseLocation.selectedItems, function (item) { return item.id; }).join(",");
    //     let product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
    //     this.sddispatchService.getBatchNo(whLocation,product)
    //     .subscribe((response) => {
    //         if (response.status) {
    //             this.ddlResponse.batch = response.data;
    //             this.loader = 'none';
    //         }
    //         else {
    //             this.loader = 'none';
    //         }

    //     }, error => {
    //         this.loader = 'none';
    //     });
    // }



    GetInvoiceNo() {
        debugger;
        this.ddlResponse.invoice = [];
        this.loader = 'block';
        let whLocation = Array.prototype.map.call(this.warehouseLocation.selectedItems, function (item) { return item.id; }).join(",");
        let product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
        this.sddispatchService.getInvoiceNo(whLocation, product)
            .subscribe((response) => {
                if (response.status) {
                    debugger;
                    //alert(response.data)
                    this.ddlResponse.invoice = response.data;
                    this.loader = 'none';
                }
                else {
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }
    GetWarehouseWiseData(filter: any) {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.WareHouse = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getWarehouseWiseRMHDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.rmh.selectedItems = [];
                    this.regionSelect.selectedItems = [];
                    this.ddlResponse.rmh = response.data.rmh;
                    this.ddlResponse.region = response.data.region;
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }





}